import { render, staticRenderFns } from "./EntityIdentity.vue?vue&type=template&id=de65713c"
import script from "./EntityIdentity.vue?vue&type=script&lang=js"
export * from "./EntityIdentity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports